'use strict';

var _require = require('fpx'),
    includes = _require.includes,
    is = _require.is,
    isList = _require.isList,
    isArray = _require.isArray,
    isDict = _require.isDict,
    isObject = _require.isObject,
    isFunction = _require.isFunction,
    validate = _require.validate;

/**
 * Interfaces
 */

exports.isDeinitable = isDeinitable;
function isDeinitable(value) {
  return Boolean(value) && isFunction(value.deinit);
}

exports.isOwner = isOwner;
function isOwner(value) {
  return isDeinitable(value) && isFunction(value.unwrap);
}

/**
 * Utils
 */

exports.deinit = deinit;
function deinit(value) {
  if (isDeinitable(value)) value.deinit();
}

exports.deinitDiff = deinitDiff;
function deinitDiff(prev, next) {
  deinitDiffAcyclic(prev, next, []);
}

exports.unwrap = unwrap;
function unwrap(value) {
  return isOwner(value) ? value.unwrap() : undefined;
}

/**
 * Internal
 */

function deinitDiffAcyclic(prev, next, visitedRefs) {
  if (is(prev, next)) return;
  if (isDeinitable(prev)) {
    prev.deinit();
    return;
  }

  if (isObject(prev)) {
    // Don't bother traversing non-plain objects. This allows to safely include
    // third party objects with unknown structure.
    if (!isDict(prev) && !isArray(prev)) return;

    // This skips cyclic references
    if (includes(visitedRefs, prev)) return;

    visitedRefs.push(prev);
    traverseDiffBy(deinitDiffAcyclic, prev, next, visitedRefs);
  }
}

// Ugly, TODO simplify
function traverseDiffBy(fun, prev, next, visitedRefs) {
  validate(isFunction, fun);

  if (isList(prev)) {
    var error = void 0;
    for (var i = -1; ++i < prev.length;) {
      var prevValue = prev[i];
      if (includes(next, prevValue)) continue;
      var nextValue = isList(next) ? next[i] : undefined;
      try {
        fun(prevValue, nextValue, visitedRefs);
      } catch (err) {
        error = err;
      }
    }
    if (error) throw error;
    return;
  }

  if (isObject(prev)) {
    var _error = void 0;
    for (var key in prev) {
      var _prevValue = prev[key];
      var _nextValue = isObject(next) ? next[key] : undefined;
      try {
        fun(_prevValue, _nextValue, visitedRefs);
      } catch (err) {
        _error = err;
      }
    }
    if (_error) throw _error;
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/espo/dist/lifetime.js
// module id = 224
// module chunks = 118